export const billingManager = {
  _format: "hh-sol-artifact-1",
  contractName: "Billing",
  sourceName: "contracts/billing/Billing.sol",
  contractAddress: {
    polygon:'0x54050BA2BB6Ef332D90810B5C960d0e53De0853D',
    base:'0x6bF33054d91919788ee5414D91A84fc647c73959',
    fvm:'0xA7f6CEeA3331a8902E84E6Bf83131f64b01b0c6c'
  },
  abi: [
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint16",
          name: "planID",
          type: "uint16",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
        {
          indexed: false,
          internalType: "bytes7",
          name: "code",
          type: "bytes7",
        },
      ],
      name: "ActivatePlanEvent",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint16",
          name: "planID",
          type: "uint16",
        },
        {
          indexed: false,
          internalType: "uint32",
          name: "totalNumOfDeduction",
          type: "uint32",
        },
        {
          indexed: false,
          internalType: "uint32",
          name: "nextDeductionInNumOfBlocks",
          type: "uint32",
        },
        {
          indexed: false,
          internalType: "uint128",
          name: "amount",
          type: "uint128",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
        {
          indexed: false,
          internalType: "bytes7",
          name: "code",
          type: "bytes7",
        },
        {
          indexed: false,
          internalType: "string",
          name: "details",
          type: "string",
        },
      ],
      name: "AddPlanEvent",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "previousAdmin",
          type: "address",
        },
        {
          indexed: false,
          internalType: "address",
          name: "newAdmin",
          type: "address",
        },
      ],
      name: "AdminChanged",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "billingContract",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenAddress",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "ApproveContract",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "beacon",
          type: "address",
        },
      ],
      name: "BeaconUpgraded",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "subscriptionId",
          type: "uint256",
        },
      ],
      name: "CancelSubscription",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint16",
          name: "planID",
          type: "uint16",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
        {
          indexed: false,
          internalType: "bytes7",
          name: "code",
          type: "bytes7",
        },
      ],
      name: "DeactivatePlanEvent",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint16",
          name: "subscriptionId",
          type: "uint16",
        },
        {
          indexed: true,
          internalType: "uint32",
          name: "increase",
          type: "uint32",
        },
      ],
      name: "IncreaseBlockNumber",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "uint8",
          name: "version",
          type: "uint8",
        },
      ],
      name: "Initialized",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "subscriptionId",
          type: "uint256",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenAddress",
          type: "address",
        },
      ],
      name: "PlanPurchased",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenAddress",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint64",
          name: "rate",
          type: "uint64",
        },
        {
          indexed: true,
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
      ],
      name: "StableCoinStatus",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          indexed: false,
          internalType: "bool",
          name: "active",
          type: "bool",
        },
        {
          indexed: true,
          internalType: "uint16",
          name: "subscriptionId",
          type: "uint16",
        },
      ],
      name: "SubscriptionStatusEvent",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "updateBy",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newImplementation",
          type: "address",
        },
      ],
      name: "UpdateContract",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "implementation",
          type: "address",
        },
      ],
      name: "Upgraded",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "receiver",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "tokenAddress",
          type: "address",
        },
        {
          indexed: true,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "WithdrawMoney",
      type: "event",
    },
    {
      stateMutability: "payable",
      type: "fallback",
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "activatePlan",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "uint32",
              name: "totalNumOfDeduction",
              type: "uint32",
            },
            {
              internalType: "uint32",
              name: "nextDeductionInNumOfBlocks",
              type: "uint32",
            },
            {
              internalType: "uint128",
              name: "amount",
              type: "uint128",
            },
            {
              internalType: "bool",
              name: "isActive",
              type: "bool",
            },
            {
              internalType: "bytes7",
              name: "code",
              type: "bytes7",
            },
          ],
          internalType: "struct IBilling.Subscription",
          name: "_sub",
          type: "tuple",
        },
        {
          internalType: "string",
          name: "_details",
          type: "string",
        },
      ],
      name: "addSubscriptionPlan",
      outputs: [
        {
          internalType: "uint16",
          name: "",
          type: "uint16",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "deactivatePlan",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "getActivePlanList",
      outputs: [
        {
          components: [
            {
              internalType: "uint256",
              name: "index",
              type: "uint256",
            },
            {
              internalType: "uint32",
              name: "totalNumOfDeduction",
              type: "uint32",
            },
            {
              internalType: "uint32",
              name: "nextDeductionInNumOfBlocks",
              type: "uint32",
            },
            {
              internalType: "uint128",
              name: "amount",
              type: "uint128",
            },
            {
              internalType: "bool",
              name: "isActive",
              type: "bool",
            },
            {
              internalType: "string",
              name: "detail",
              type: "string",
            },
          ],
          internalType: "struct IBilling.ISubscription[]",
          name: "",
          type: "tuple[]",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_tokenAddress",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "getPayableAmount",
      outputs: [
        {
          internalType: "uint256",
          name: "installment",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "totalValue",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_user",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "getSubscriptionStatus",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
        {
          internalType: "uint16",
          name: "",
          type: "uint16",
        },
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_tokenAddress",
          type: "address",
        },
      ],
      name: "getTokenbalance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_user",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "getUserDeductionLeft",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_user",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "getUserPurchaseCount",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
        {
          internalType: "uint32",
          name: "_increase",
          type: "uint32",
        },
      ],
      name: "increaseBlockNumber",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "initialize",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "",
          type: "uint16",
        },
      ],
      name: "planDetails",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "proxiableUUID",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
        {
          internalType: "address",
          name: "_tokenAddress",
          type: "address",
        },
      ],
      name: "purchasePlan",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_user",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "renewSubscription",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      name: "stableCoinStatus",
      outputs: [
        {
          internalType: "uint64",
          name: "rate",
          type: "uint64",
        },
        {
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      name: "subscriptionList",
      outputs: [
        {
          internalType: "uint32",
          name: "totalNumOfDeduction",
          type: "uint32",
        },
        {
          internalType: "uint32",
          name: "nextDeductionInNumOfBlocks",
          type: "uint32",
        },
        {
          internalType: "uint128",
          name: "amount",
          type: "uint128",
        },
        {
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
        {
          internalType: "bytes7",
          name: "code",
          type: "bytes7",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint16",
          name: "_subscriptionId",
          type: "uint16",
        },
      ],
      name: "unsubscribe",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_tokenAddress",
          type: "address",
        },
        {
          components: [
            {
              internalType: "uint64",
              name: "rate",
              type: "uint64",
            },
            {
              internalType: "bool",
              name: "isActive",
              type: "bool",
            },
          ],
          internalType: "struct IBilling.StableCoinState",
          name: "_stableCoin",
          type: "tuple",
        },
      ],
      name: "updateStableCoin",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newImplementation",
          type: "address",
        },
      ],
      name: "upgradeTo",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newImplementation",
          type: "address",
        },
        {
          internalType: "bytes",
          name: "data",
          type: "bytes",
        },
      ],
      name: "upgradeToAndCall",
      outputs: [],
      stateMutability: "payable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "",
          type: "uint16",
        },
      ],
      name: "userPlanDetails",
      outputs: [
        {
          internalType: "uint32",
          name: "deductionLeft",
          type: "uint32",
        },
        {
          internalType: "uint96",
          name: "lastDebit",
          type: "uint96",
        },
        {
          internalType: "uint16",
          name: "subscriptionId",
          type: "uint16",
        },
        {
          internalType: "uint96",
          name: "createdAt",
          type: "uint96",
        },
        {
          internalType: "bool",
          name: "isCancelled",
          type: "bool",
        },
        {
          internalType: "address",
          name: "tokenAddress",
          type: "address",
        },
        {
          internalType: "uint16",
          name: "purchasedCount",
          type: "uint16",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_tokenAddress",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "_amount",
          type: "uint256",
        },
        {
          internalType: "address",
          name: "_receiver",
          type: "address",
        },
      ],
      name: "withdrawTokens",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      stateMutability: "payable",
      type: "receive",
    },
  ],
  linkReferences: {},
  deployedLinkReferences: {},
};
